import state from './state.js'
import getters from './getters.js'
import actions from './actions.js'

const storeOptions = {
  state,
  getters,
  actions,
  persist: {
    storage: piniaPluginPersistedstate.localStorage(),
    pick: ['quotes', 'quotes_fetched_at', 'quotes_user_id']
  }
}

export const useQuotesStore = defineStore('quotes', storeOptions)
